import a from "./index42.js";
const r = a.default || a;
export {
  r as default
};
